var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RNPForm default"},[_c('div',{staticClass:"FormMain"},[_c('div',{staticClass:"to_vertical",attrs:{"id":"content"},domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('div',{attrs:{"id":"preview"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }